<main class="sh-page sh-events" *ngIf="showPage">
  <!-- HERO -->
  <header class="sh-hero sh-events__hero" [style.background-image]="content.hero.image ? 'url(' + content.hero.image + ')' : null">
    <div class="sh-hero__overlay"></div>
    <div class="sh-wrap sh-hero__inner sh-events__hero-inner">
      <span class="sh-eyebrow sh-eyebrow--light">{{ content.hero.eyebrow }}</span>
      <h1 class="sh-display">{{ content.hero.title }}</h1>
      <p class="sh-events__kicker">{{ content.hero.kicker }}</p>
      <div class="sh-btn-row sh-events__hero-cta">
        <a class="sh-btn sh-btn--white" href="#events-cta">{{ content.hero.ctaLabel }}</a>
      </div>
    </div>
  </header>

  <div class="sh-events__label-bar">{{ content.labelBar }}</div>

  <!-- HOOK -->
  <section class="sh-section sh-section--tight">
    <div class="sh-wrap sh-wrap--narrow">
      <p class="sh-lede sh-events__hook">{{ content.hook }}</p>
    </div>
  </section>

  <!-- PERKS -->
  <section class="sh-section sh-section--tight">
    <div class="sh-wrap sh-events__perks">
      <div class="sh-events__circle"><span *ngFor="let word of content.perks.circle">{{ word }}</span></div>
      <div class="sh-events__perks-body">
        <h3>{{ content.perks.heading }}</h3>
        <ul class="sh-check-list sh-check-list--dark">
          <li *ngFor="let item of content.perks.includes">{{ item }}</li>
        </ul>
        <p class="sh-events__note">{{ content.perks.note }}</p>
      </div>
    </div>
  </section>

  <!-- GALLERY -->
  <section class="sh-section sh-section--tight" *ngIf="content.gallery.images?.length">
    <div class="sh-wrap">
      <div class="sh-section-head"><span class="sh-bar"></span><h2>{{ content.gallery.heading }}</h2></div>
      <div class="sh-events__gallery">
        <img *ngFor="let src of content.gallery.images" [src]="src" alt="Celebration at Steelhaus" width="800" height="600" loading="lazy" decoding="async" />
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="sh-section" id="events-cta">
    <div class="sh-wrap">
      <div class="sh-callout sh-events__cta">
        <div>
          <h3>{{ content.cta.heading }}</h3>
          <p>
            {{ content.cta.text }}<br />
            <a class="sh-events__email" [href]="'mailto:' + content.cta.email">{{ content.cta.email }}</a>
          </p>
        </div>
        <a class="sh-btn sh-btn--blue" [href]="content.cta.inquiryUrl" target="_blank" rel="noopener">{{ content.cta.ctaLabel }}</a>
      </div>
    </div>
  </section>
</main>

<div class="sh-unavailable sh-wrap" *ngIf="!showPage">
  <h2>Page not available</h2>
  <p>This page isn't enabled for this location.</p>
  <a routerLink="/" class="sh-btn sh-btn--blue">Back to Home</a>
</div>
